// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kAiI","colBig":"styles_colBig__1zik0","colSmall":"styles_colSmall__CSa0V"};